import React from 'react';
import Avatar from '@mui/material/Avatar';

// Stores that never uploaded a real logo still have a non-null logo_url — the backend
// backfills this exact placeholder for them (see migrate.js) — so it must be treated the
// same as "no logo" rather than shown as if it were the store's own branding.
const DEFAULT_LOGO_URL = 'https://placehold.co/200x200?text=Logo';

function StoreLogoBadge({ src, alt, size = 44 }) {
    if (!src || src === DEFAULT_LOGO_URL) return null;
    return (
        <Avatar
            src={src}
            alt={alt}
            variant="rounded"
            sx={{
                position: 'absolute',
                bottom: 10,
                right: 10,
                width: size,
                height: size,
                zIndex: 2,
                border: '2px solid',
                borderColor: 'background.paper',
                boxShadow: '0 2px 10px rgba(0,0,0,0.4)',
                bgcolor: 'background.paper',
            }}
        />
    );
}

export default StoreLogoBadge;
